import axios from "axios";
import api from "./axios";

const BASE_URL = `${process.env.REACT_APP_API_BASE_URL}/api/v1`;

export const getBoardCertifications = async () => {
  const response = await api.get(`${BASE_URL}/admin/board-certifications`);
  return response.data; // returns list of { id, name }
};

export const getUniversities = async (page = 4, size = 500, search = "") => {
  const response = await api.get(`${BASE_URL}/universities`, {
    params: { page, size, search },
  });
  return response.data.content; // [{ id, name, city, state }]
};

export const getSpecialties = async () => {
  const response = await api.get(
    `${process.env.REACT_APP_API_BASE_URL}/specialties`,
  );
  return response.data;
};

export const getInsurancePlans = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/admin/insurance-plans`);
    if (response.data.content) {
      return response.data.content;
    }

    return response.data;
  } catch (error) {
    console.error("Error fetching insurance plans:", error);
    return [];
  }
};
